import { Action } from '@components/icons'
import { Container } from '@components/ui'
import config from '@config/seo_meta.json'
import { useTranslation } from 'next-i18next'
import Image from 'next/legacy/image'
import Link from 'next/link'
import { useState } from 'react'

interface Props {
  slice: any
}

const FourColumnCard = ({ slice }: Props) => {
  const [isHover, setIsHover] = useState(false)
  const { t } = useTranslation('common')
  const [hoveredIndex, setHoveredIndex] = useState(-1)
  const handleHover = (index: number) => {
    setIsHover(true)
    setHoveredIndex(index)
  }
  const handleLeave = () => {
    setHoveredIndex(-1)
    setIsHover(false)
  }
  const items = slice?.items

  return (
    <Container
      clean={!slice?.primary?.insideContainer}
      className="lg:grid lg:grid-cols-4 lg:gap-x-8 lg:gap-y-10"
    >
      {items?.map((item: any, i: number) => {
        const url = item?.catImage?.url
        const mobileUrl = item?.catImageMobile?.url
        const alt = item?.catImage?.alt
        const catName = item?.catName
        const title = item?.title
        const description = item?.description
        const navLink = item?.link || '/'

        return (
          navLink && (
            <Link
              href={navLink}
              target={'_blank'}
              passHref
              key={i}
              legacyBehavior
            >
              <div
                className="cursor-pointer"
                onMouseOver={() => handleHover(i)!}
                onMouseLeave={() => handleLeave()}
              >
                {url && (
                  <div className="pb-3">
                    <div className="hidden lg:block">
                      <Image
                        src={url}
                        alt={alt || config.openGraph.images[0].alt}
                        width={768}
                        height={1024}
                      />
                    </div>
                    <div className="lg:hidden">
                      <Image
                        src={mobileUrl ? mobileUrl : url}
                        alt={alt || config.openGraph.images[0].alt}
                        width={1024}
                        height={768}
                      />
                    </div>
                  </div>
                )}
                {catName && (
                  <div className="pb-3 text-[13px] font-bold">{catName}</div>
                )}
                {title && (
                  <div className="heading-mobile-4 lg:heading-4 min-h-13 pb-3 text-brand-dark-grey lg:min-h-16">
                    {title}
                  </div>
                )}
                {description && <div className="pb-3">{description}</div>}
                <div>
                  <div className="flex items-center gap-3 pb-10 lg:pb-0">
                    <div>{t('learn-more')}</div>
                    <div>
                      {isHover && i === hoveredIndex ? (
                        <Action hover></Action>
                      ) : (
                        <Action></Action>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          )
        )
      })}
    </Container>
  )
}

export default FourColumnCard
